import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.initSelect2(document.getElementById("level_one_select"))
    this.initSelect2(document.getElementById("level_two_select"))

    const levelOneSelect = document.getElementById("level_one_select")
    if (levelOneSelect) {
      $(levelOneSelect).on("select2:select select2:unselect", (e) => {
        this.levelOneChanged(e)
      })
    }
  }

  initSelect2(el, options = {}) {
    if (!el) return
    if (typeof $ === "undefined" || !$.fn.select2) return

    if ($(el).hasClass("select2-hidden-accessible")) {
      $(el).select2("destroy")
    }

    $(el).select2({
      width: "240px",
      dropdownCssClass: "custom-search-dropdown",
      ...options
    })

    const container = $(el).next(".select2-container")
    const selection = container.find(".select2-selection")
    selection.addClass("form-control d-flex align-items-center")
    selection.css({
      height: 42,
      border: "1px solid #E4E6EF",
      borderRadius: "0.5rem"
    })

    container.find(".select2-selection__rendered").css({
      lineHeight: "42px",
      paddingLeft: "8px"
    })

    container.find(".select2-selection__arrow").hide()
  }

  levelOneChanged(event) {
    const levelOneId = event.params?.data?.id || $(event.target).val()
    const levelTwoSelect = document.getElementById("level_two_select")

    $(levelTwoSelect).empty().append(new Option("全て", ""))

    if (!levelOneId) {
      $(levelTwoSelect).trigger("change")
      return
    }

    fetch(`/biometric_logs?level_one_id=${levelOneId}&format=json`)
      .then(r => r.json())
      .then(data => {
        data.level_twos.forEach(lt => {
          $(levelTwoSelect).append(new Option(lt.name, lt.id))
        })
        $(levelTwoSelect).trigger("change")
      })
  }

  disconnect() {
    ;["level_one_select", "level_two_select"].forEach(id => {
      const el = document.getElementById(id)
      if (el && $(el).hasClass("select2-hidden-accessible")) {
        $(el).off("select2:select select2:unselect")
        $(el).select2("destroy")
      }
    })
  }
}